import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcAvatarModule } from 'mwc/avatar';
import { MwcDropDownModule } from 'mwc/dropdown';
import { FixedWidgetsComponent } from './fixed-widgets.component';
import { ThemingIcon } from './theme-icons'

@NgModule({
  declarations: [
    FixedWidgetsComponent,
    ThemingIcon
  ],
  imports: [
    CommonModule,
    MwcAvatarModule,
    MwcDropDownModule
  ],
  exports: [FixedWidgetsComponent]
})
export class FixedWidgetsModule { }
